<template>
  <section
    id="admin-agent-list"
    :dir="$functions.currentLangDirection()"
  >
    <b-card class="admin-page-mobile">
      <b-button
        class="btn-sm mb-1"
        :variant="isMobile ? 'outline-light': 'outline-primary'"
        @click="showNewAgentModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="22"
          class="align-text-top"
        />
        نماینده جدید
      </b-button>
      <b-button
        class="btn-sm mb-1 ml-1 mr-1"
        :variant="isMobile ? 'outline-light': 'outline-secondary'"
        @click="showModal"
      >
        <feather-icon
          icon="UserCheckIcon"
          size="22"
          class="align-text-top"
        />
        نماینده کردن کاربر موجود
      </b-button>

      <v-data-table
        v-bind="{dark : isMobile }"
        :headers="headers"
        :items="desserts"
        :search="search"
        mobile-breakpoint="0"
        loading
        :loading-text="$t('Loading')"
        :items-per-page="50"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('Search')"
            class="mx-4"
            style=""
          />
        </template>
        <template v-slot:item.type="{ item }">
          {{ item.type === 1 ? 'نماینده' : item.type }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            @click="onEditItem(item)"
          >
            mdi-circle-edit-outline
          </v-icon>
          <v-icon
            style="margin-right: 7px"
            @click="onDeleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </b-card>

    <!-- modal: ساخت نماینده جدید -->
    <b-modal
      id="modal-newAgent"
      ref="modal-newAgent"
      cancel-variant="outline-secondary"
      :ok-title="$t('Add')"
      :cancel-title="$t('Close')"
      centered
      title="نماینده جدید"
    >
      <b-form @submit.prevent="modalNewAgentOk()">
        <b-form-group
          label="شماره موبایل:"
          label-for="v-agent-mobile"
        >
          <b-form-input
            id="v-agent-mobile"
            v-model="newAgent.mobile"
            class="numeric-input"
            maxlength="11"
            placeholder="09xxxxxxxxx"
            required
          />
        </b-form-group>
        <b-form-group
          label="نام:"
          label-for="v-agent-name"
        >
          <b-form-input
            id="v-agent-name"
            v-model="newAgent.name"
            required
          />
        </b-form-group>
        <b-form-group
          label="نام خانوادگی:"
          label-for="v-agent-family"
        >
          <b-form-input
            id="v-agent-family"
            v-model="newAgent.family"
          />
        </b-form-group>
        <small class="text-muted">
          شماره موبایل شناسه ورود نماینده است و باید یکتا باشد.
        </small>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="$bvModal.hide('modal-newAgent')"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          :disabled="saving"
          @click="modalNewAgentOk()"
        >
          {{ $t('Save') }}
        </b-button>
      </template>
    </b-modal>

    <!-- modal: نماینده کردن کاربر موجود -->
    <b-modal
      id="modal-addAgent"
      ref="modal-addAgent"
      cancel-variant="outline-secondary"
      :ok-title="$t('Add')"
      :cancel-title="$t('Close')"
      centered
      title="نماینده کردن کاربر موجود"
    >
      <b-form>
        <b-form-group
          label="لیست کاربران:"
          label-for="vi-port"
        >
          <b-input-group class="input-group-merge">
            <model-list-select
              v-model="selected"
              :list="options"
              option-value="_id"
              :custom-text="optionDisplayText"
              placeholder="کاربران"
            />
          </b-input-group>
        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          :disabled="saving"
          @click="modalOk()"
        >
          {{ $t('Save') }}
        </b-button>
      </template>
    </b-modal>
  </section>

</template>
<script>
import {
  BCard, BCardBody, BButton, BModal, BForm, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupPrepend, BCardHeader,
} from 'bootstrap-vue'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Vue from 'vue'
import router from '@/router'
import customerService from '@/services/customer.service'
import Customer from '@/models/customer'
import { ModelListSelect } from 'vue-search-select'

import 'vue-search-select/dist/VueSearchSelect.css'
export default {
  components: {
    ModelListSelect,
    BCardHeader,
    BCard,
    BModal,
    BButton,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      search: '',
      customer: new Customer('', '', '', '', '', ''),
      newAgent: { name: '', family: '', mobile: '' },
      saving: false,
      desserts: [],
      selected: '',
      options: [],
      required,
      footerProps: { 'items-per-page-options': [10, 25, 50, 100, -1] },
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'نام',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'نام خانوادگی', value: 'family' },
        { text: 'شماره موبایل', value: 'mobile' },
        { text: 'نوع', value: 'type' },
        { text: 'تاریخ ایجاد', value: 'creationDate' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async mounted() {
    this.initializeOption()
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    optionDisplayText(animation) {
      return `${animation.name} ${animation.family} - ${animation.mobile}`
    },
    // تبدیل ارقام فارسی/عربی به لاتین و حذف کاراکترهای غیرعددی
    normalizeDigits(value) {
      if (!value) return ''
      const fa = '۰۱۲۳۴۵۶۷۸۹'
      const ar = '٠١٢٣٤٥٦٧٨٩'
      return String(value)
        .replace(/[۰-۹]/g, d => fa.indexOf(d))
        .replace(/[٠-٩]/g, d => ar.indexOf(d))
        .replace(/[^0-9]/g, '')
    },
    showToast(title, text, variant = 'danger') {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant,
          dir: Vue.prototype.$functions.currentLangDirection(),
        },
      })
    },
    initializeOption() {
      try {
        customerService.getAll({ type: 0 }).then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.options = res.result.data
              } else {
                this.options = []
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }
    },
    initialize() {
      this.desserts = []
      customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            // console.log(res.status)
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.showToast(this.$t('Error'), this.message)
        },
      )
    },
    addClick() {
      router.push({ path: '/admin/agent/add' })
    },
    // ساخت نماینده جدید بدون نیاز به انتخاب از بین کاربران
    modalNewAgentOk() {
      const mobile = this.normalizeDigits(this.newAgent.mobile)
      const name = (this.newAgent.name || '').trim()
      const family = (this.newAgent.family || '').trim()

      if (!/^09\d{9}$/.test(mobile)) {
        this.showToast(this.$t('Error'), 'شماره موبایل باید ۱۱ رقم و با 09 شروع شود.')
        return
      }
      if (name.length < 2) {
        this.showToast(this.$t('Error'), 'نام باید حداقل ۲ حرف باشد.')
        return
      }

      this.saving = true
      customerService.addAgentUser({ name, family, mobile }).then(
        res => {
          this.saving = false
          if (res.status === 'success') {
            this.$bvModal.hide('modal-newAgent')
            this.newAgent = { name: '', family: '', mobile: '' }
            this.initialize()
            this.initializeOption()
            this.showToast('انجام شد', 'نماینده جدید ثبت شد.', 'success')
            return
          }
          // شماره متعلق به یک کاربر عادی است: پیشنهاد ارتقا به نماینده
          const result = res.result || {}
          if (result.code === 'USER_EXISTS' && result._id) {
            // eslint-disable-next-line no-alert, no-restricted-globals
            if (confirm(`${res.message}\nهمین کاربر به نماینده تبدیل شود؟`)) {
              this.promoteToAgent(result._id)
              return
            }
          }
          this.showToast(this.$t('Error'), res.message)
        },
        error => {
          this.saving = false
          this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
          this.showToast(this.$t('Error'), this.message)
        },
      )
    },
    promoteToAgent(id) {
      this.saving = true
      customerService.addAgent({ _id: id }).then(
        res => {
          this.saving = false
          if (res.status === 'success') {
            this.$bvModal.hide('modal-newAgent')
            this.$bvModal.hide('modal-addAgent')
            this.newAgent = { name: '', family: '', mobile: '' }
            this.selected = ''
            this.initialize()
            this.initializeOption()
            this.showToast('انجام شد', 'کاربر به نماینده تبدیل شد.', 'success')
          } else {
            this.showToast(this.$t('Error'), res.message)
          }
        },
        error => {
          this.saving = false
          this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
          this.showToast(this.$t('Error'), this.message)
        },
      )
    },
    modalOk() {
      if (!this.selected) {
        this.showToast(this.$t('Error'), 'یک کاربر را انتخاب کنید.')
        return
      }
      this.promoteToAgent(this.selected)
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        customerService.removeAgent({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.showToast(this.$t('Error'), res.message)
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.showToast(this.$t('Error'), this.message)
          },
        )
      } else {
        index = ''
      }
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      const id = this.desserts[index]._id
      router.push({ name: 'admin-agent-edit', params: { id } })
    },
    showNewAgentModal() {
      this.newAgent = { name: '', family: '', mobile: '' }
      this.$refs['modal-newAgent'].show()
    },
    showModal() {
      this.initializeOption()
      this.$refs['modal-addAgent'].show()
    },
    hideModal() {
      this.$refs['modal-addAgent'].hide()
    },
  },
}
</script>
